import { ReactNode } from 'react';
import classNames from 'classnames';

import styles from './Tag.module.css';

type Props = {
    children: ReactNode;
    active?: boolean;
    disabled?: boolean;
    onClick?: VoidFunction;
}

export const Tag = ({ children, active, disabled, onClick }: Props) => (
    <button className={classNames(styles.tag, active && styles.active)} onClick={onClick} disabled={disabled}>{children}</button>
);
